function CWCOMMON() {}

CWCOMMON.prototype.SUPPORT = function () {
    var cwWindow = window;
    var pnlWarranty = document.getElementById('pnlWarranty');
    var warrantyContent = document.getElementById('supportWarranty');
    var warrantyFirstParagraph = warrantyContent ? warrantyContent.querySelector('p:first-child') : null;
    var warrantyTitle = pnlWarranty ? pnlWarranty.querySelector('h2') : null;
    var firstCategoryExpanded = false;

    function setupToExpandFirstCategory() {
        var currURL = location.href;
        if (currURL.indexOf('#') < 0) {
            expandFirstCategory();
        }
        var target = document.getElementById('supportQuestions');
        var observer = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting) {
                if (firstCategoryExpanded == false) {
                    expandFirstCategory();
                }
                observer.unobserve(target);
            }
        }, {
            threshold: 0.1
        });
        observer.observe(target);
    }
    function slideDown(element, duration) {
      duration = duration || 700;
      element.style.display = 'block';
      var height = element.clientHeight;
      element.style.height = '0px';
      element.style.overflow = 'hidden';
      element.style.transition = 'height ' + duration + 'ms';

      requestAnimationFrame(function() {
          element.style.height = height + 'px';
      });

      setTimeout(function() {
          element.style.height = '';
          element.style.overflow = '';
          element.style.transition = '';
      }, duration);
    }
    function slideUp(element, duration) {
      duration = duration || 700;
      var height = element.clientHeight;
      element.style.height = height + 'px';
      element.style.overflow = 'hidden';
      element.style.transition = 'height ' + duration + 'ms';

      requestAnimationFrame(function() {
          element.style.height = '0px';
      });

      setTimeout(function() {
          element.style.display = 'none';
          element.style.height = '';
          element.style.overflow = '';
          element.style.transition = '';
      }, duration);
    }

    function scrollToExpandFirstCategory() {}

    function expandFirstCategory() {
      setTimeout(function () {
          var firstQuestion = document.querySelector('#supportQuestions li:first-child');
          if (firstQuestion) {
              var sQuestions = firstQuestion.querySelector('.sQuestions');
              var categoryName = firstQuestion.querySelector('.categoryName');
              if (sQuestions) slideDown(sQuestions);
              if (categoryName) {
                  categoryName.classList.remove('arrowBigRight');
                  categoryName.classList.add('arrowBigDown');
              }
          }
      }, 1300);
      firstCategoryExpanded = true;
    }
    function attachEvents() {
      function onResizeOrOrientationChange() {}
      cwWindow.removeEventListener('resize', onResizeOrOrientationChange);
      cwWindow.removeEventListener('orientationchange', onResizeOrOrientationChange);
      cwWindow.addEventListener('resize', onResizeOrOrientationChange);
      cwWindow.addEventListener('orientationchange', onResizeOrOrientationChange);

      cwWindow.removeEventListener('scroll', scrollToExpandFirstCategory);
      cwWindow.addEventListener('scroll', scrollToExpandFirstCategory);

      document.querySelectorAll('.expandMore').forEach(function (element) {
          element.addEventListener('click', function () {
              var expandPanel = document.getElementById('pnlWarranty');
              if (expandPanel) {
                  expandPanel.style.maxHeight = warrantyPanelMaxHeight + 'px';
                  element.style.display = 'none';
                  var expandLess = element.nextElementSibling;
                  if (expandLess) expandLess.style.display = 'block';
              }
          });
      });

      document.querySelectorAll('.expandLess').forEach(function (element) {
          element.addEventListener('click', function () {
              var expandPanel = document.getElementById('pnlWarranty');
              if (expandPanel) {
                  expandPanel.style.maxHeight = warrantyPanelMinHeight + 'px';
                  element.style.display = 'none';
                  var expandMore = element.previousElementSibling;
                  if (expandMore) expandMore.style.display = 'block';
              }
          });
      });

      document.querySelectorAll('.categoryName').forEach(function (element) {
          element.addEventListener('click', function () {
              var sQuestions = element.parentElement.querySelector('.sQuestions');
              if (sQuestions) {
                  if (sQuestions.style.display === 'none' || sQuestions.style.display === '') {
                      slideDown(sQuestions);
                  } else {
                      slideUp(sQuestions);
                  }
              }
              if (element.classList.contains('arrowBigRight')) {
                  element.classList.remove('arrowBigRight');
                  element.classList.add('arrowBigDown');
              } else {
                  element.classList.remove('arrowBigDown');
                  element.classList.add('arrowBigRight');
              }
          });
      });

      document.querySelectorAll('.questionName').forEach(function (element) {
          element.addEventListener('click', function () {
              var sAnswers = element.parentElement.querySelector('.sAnswers');
              if (sAnswers) {
                  if (sAnswers.style.display === 'none' || sAnswers.style.display === '') {
                      slideDown(sAnswers);
                  } else {
                      slideUp(sAnswers);
                  }
              }
              if (element.classList.contains('arrowSmallRight')) {
                  element.classList.remove('arrowSmallRight');
                  element.classList.add('arrowSmallDown');
              } else {
                  element.classList.remove('arrowSmallDown');
                  element.classList.add('arrowSmallRight');
              }
          });
      });
    }

    attachEvents();
    setupToExpandFirstCategory();
};

document.addEventListener('DOMContentLoaded', function () {
    var myCWCOMMON = new CWCOMMON();
    document.querySelectorAll('#cwSupport, .supportArea').forEach(function () {
        myCWCOMMON.SUPPORT();
    });
});
